import React from 'react';
import SIcon from './SIcon';
import { faSignalFair } from '@fortawesome/pro-duotone-svg-icons';

const Icon = props => <SIcon {...props} icon={faSignalFair} fa />;

export default Icon;
